export default {"src":"/_next/static/media/rowing.mono.c044728c.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};